/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation DeleteDocumentSouscriptionSupportingDocumentsMutation($input: DeleteDocumentSouscriptionSupportingDocuments_M_souscription_supporting_documentsInput!) {
    deleteDocumentSouscriptionSupportingDocuments_M_souscription_supporting_documents(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
